import './App'
import { setLevel } from './common/utils/logger'

export default {
    setLevel,
}



// WEBPACK FOOTER //
// /src/js/index.jsx